export const dropDowns = {
    yesNoOptions: [
        { name : '' , value : 'QUESTION'},
        { name : 'Yes' , value : 'YES'},
        { name : 'No' , value : 'NO'}
    ],
    yesNoOptionsMandatory: [
        { name : 'Please Select' , value : ''},
        { name : 'Yes' , value : 'YES'},
        { name : 'No' , value : 'NO'}
    ],
    yesNoOnlyOptions:[
        { name : 'Yes' , value : 'YES'},
        { name : 'No' , value : 'NO'}
    ],
    firstTimeHomeBuyerOptions:[
        { name : 'Yes' , value : 'Yes'},
        { name : 'No' , value : 'No'}
    ],
    genderOptions : [
        { name : '' , value : ''},
        { name : 'male' , value : 'MALE'},
        { name : 'female' , value : 'FEMALE'}
    ],
    residentStatusOptions : [
        { name : '' , value : ''},
        { name : 'Canadian Citizen' , value : 'CANADIAN_CITIZEN'},
        { name : 'Permanent Resident' , value : 'PERMANENT_RESIDENT'}
    ],
    spousalStatusOptions: [
        { name : '' , value : ''},
        { name : 'Not Married' , value : 'NOT_MARRIED'},
        { name : ' Married' , value : 'MARRIED'},
        { name : ' Common Law' , value : 'COMMON_LAW'},
        { name : ' Separated' , value : 'SEPARATED'}
    ],
    countryList: [
        { name: 'Canada', value: 'CANADA' },
        { name: 'USA', value: 'USA' }
    ],
    provinceOptions: [
        { name: '', value: '' },
        { name: 'Alberta', value: 'AB' },
        { name: 'British Columbia', value: 'BC' },
        { name: 'Manitoba', value: 'MB' },
        { name: 'Newfoundland and Labrador', value: 'NL' },
        { name: 'New Brunswick', value: 'NB' },
        { name: 'Northwest Territories', value: 'NT' },
        { name: 'Nova Scotia', value: 'NS' },
        { name: 'Nunavut', value: 'NU' },
        { name: 'Ontario', value: 'ON' },
        { name: 'Prince Edward Island', value: 'PE' },
        { name: 'Quebec', value: 'QC' },
        { name: 'Saskatchewan', value: 'SK' },
        { name: 'Yukon', value: 'YT' }
    ],
    /*identificationOptions: [
        { name: '', value: '' },
        { name: IdentificationOptions.birthCertificate, value: IdentificationOptions.birthCertificate },
        { name: IdentificationOptions.driverLicense, value: IdentificationOptions.driverLicense },
        { name: IdentificationOptions.canadianPassport, value: IdentificationOptions.canadianPassport },
        { name: IdentificationOptions.certificateOfCanadianCitizenship, value: IdentificationOptions.certificateOfCanadianCitizenship },
        { name: IdentificationOptions.certificateOfNaturalization, value: IdentificationOptions.certificateOfNaturalization },
        { name: IdentificationOptions.permanentResidenceCard, value: IdentificationOptions.permanentResidenceCard },
        { name: IdentificationOptions.foreignPassport, value: IdentificationOptions.foreignPassport },
    ],*/
    matterPurchasersCapacityOptions: [
        {name: '', value: '' },
        {name: "I don't know", value: 'I_DONT_KNOW'},

    ],

    matterPurchasersCapacityOptionsAB: [
        {name: '', value: '' },
        {name: "I don't know", value: 'I_DONT_KNOW'},
        {name: "As joint tenants", value: 'JOINT_TENANTS'},
        {name: "As tenants in common", value: 'TENANTS_IN_COMMON_UNSPECIFIED_SHARES'},
        {name: "Other", value: 'OTHER'}

    ],

    agentRoleOptions: [
        {name: "CLIENT", value: 'USER_CLIENT'},
        {name: "BROKER", value: 'USER_BROKER'},
        {name: "REALTOR", value: 'USER_REALTOR'}

    ],

    clientRoleOptionsP_S: [
        {value: "BUYER", name: 'Buyer'},
        {value: "SELLER", name: 'Seller'}
    ],

    clientRoleOptionsM: [
        {value: "OWNER", name: 'Owner'}

    ],

    transactionType: [
        {value: "PURCHASE", name: 'Purchase'},
        {value: "SALE", name: 'Sale'},
        {value: "REFINANCE", name: 'Refinance'}
    ],


    purchaseOf: [
        {name: '', value: '' },
        {value: "NEW_HOME", name: 'New Home'},
        {value: "RESALE", name: 'Resale'}
    ]


};

